import { render, staticRenderFns } from "./view-stockadjustment.vue?vue&type=template&id=9896cc6e&"
import script from "./view-stockadjustment.vue?vue&type=script&lang=js&"
export * from "./view-stockadjustment.vue?vue&type=script&lang=js&"
import style0 from "./view-stockadjustment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports